import { useApolloClient } from "@apollo/client";
import React from "react";
import { useToggleDecisionOptionPreselectionMutation } from "../../doc-items/fields/DecisionOptionRadioOrCheckbox.generated.js";

interface Options {
  projectId: string | null;
  docId: string;
  expandedItemIds: string[] | undefined;
}

export type ToggleDecisionOptionFn = (
  itemId: string,
  decisionOptionId: string
) => Promise<void>;

export function useDecisionOptionToggle({
  projectId,
  docId,
  expandedItemIds,
}: Options) {
  const client = useApolloClient();
  const [toggleMutation] = useToggleDecisionOptionPreselectionMutation({
    client,
  });

  const expandedItemIdsRef = React.useRef(expandedItemIds);
  React.useEffect(() => {
    expandedItemIdsRef.current = expandedItemIds;
  });

  const toggleDecisionOption: ToggleDecisionOptionFn = React.useCallback(
    async (itemId, decisionOptionId) => {
      const result = await toggleMutation({
        variables: {
          input: {
            projectId,
            docId,
            itemId,
            decisionOptionId,
            expandedItemIds: expandedItemIdsRef.current,
          },
        },
      });
      if (result.errors?.length) {
        throw new Error(result.errors[0].message);
      }
      if (!result.data) {
        throw new Error("Could not toggle decision option");
      }
    },
    [toggleMutation, projectId, docId]
  );

  return { toggleDecisionOption };
}
